<ng-template #settingsTemplate>
    <app-tool-setting label="Vul in">
        <app-numbers-input
            (numberChoice)="handleNumberChoice($event)"
            (undo)="handleUndo()"
            (clear)="handleClear()"
        ></app-numbers-input>
    </app-tool-setting>
</ng-template>
<ng-template #contentTemplate>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 222 280"
        style="width: 222px; height: 280px"
    >
        <defs>
            <style>
                .mSquare-1,
                .mSquare-2,
                .mSquare-3,
                .mSquare-6 {
                    fill: none;
                }

                .mSquare-1,
                .mSquare-2,
                .mSquare-3 {
                    stroke: #1d1d1b;
                }

                .mSquare-1,
                .mSquare-4 {
                    stroke-width: 1.5px;
                }

                .mSquare-2 {
                    stroke-width: 1.43px;
                }

                .mSquare-3 {
                    stroke-width: 1.49px;
                }

                .mSquare-4 {
                    fill: #fff;
                    stroke: #0090c9;
                }

                .mSquare-5 {
                    font-size: 26px;
                    font-family: UniversLTStd, Univers LT Std;
                }

                .mSquare-6 {
                    stroke: #a1a1a1;
                }
            </style>
        </defs>
        <line class="mSquare-1" x1="198" y1="82" x2="24" y2="82" />
        <line class="mSquare-2" x1="200.39" y1="21.23" x2="24" y2="197" />
        <line class="mSquare-1" x1="190.61" y1="247.94" x2="24" y2="82" />
        <line class="mSquare-3" x1="139.63" y1="256" x2="139.63" y2="82" />
        <line class="mSquare-1" x1="198" y1="139.63" x2="24" y2="139.63" />
        <line class="mSquare-3" x1="82" y1="256" x2="82" y2="82" />
        <line class="mSquare-1" x1="198" y1="197.25" x2="24" y2="197.25" />
        <line class="mSquare-3" x1="24.38" y1="256" x2="24.38" y2="82" />

        <g class="magic-square-item-fields">
            <g class="field0" (click)="setActiveField(0)">
                <circle class="mSquare-4" cx="198" cy="24" r="23.25" />
                <text
                    class="mSquare-5"
                    text-anchor="middle"
                    transform="translate(197.75 34.52)"
                >
                    {{ values[0] }}
                </text>
                @if (activeField === 0) {
                <g>
                    <line
                        class="mSquare-6"
                        x1="182.23"
                        y1="37.18"
                        x2="214.14"
                        y2="37.18"
                    />
                </g>
                }
            </g>
            <g class="field1" (click)="setActiveField(1)">
                <rect
                    class="mSquare-4"
                    x="0.75"
                    y="58.75"
                    width="46.5"
                    height="46.5"
                />
                <text
                    class="mSquare-5"
                    text-anchor="middle"
                    transform="translate(23.75 92.52)"
                >
                    {{ values[1] }}
                </text>
                @if (activeField === 1) {
                <g>
                    <line
                        class="mSquare-6"
                        x1="8.23"
                        y1="95.18"
                        x2="40.14"
                        y2="95.18"
                    />
                </g>
                }
            </g>
            <g class="field2" (click)="setActiveField(2)">
                <rect
                    class="mSquare-4"
                    x="58.75"
                    y="58.75"
                    width="46.5"
                    height="46.5"
                />
                <text
                    class="mSquare-5"
                    text-anchor="middle"
                    transform="translate(81.75 92.52)"
                >
                    {{ values[2] }}
                </text>
                @if (activeField === 2) {
                <g>
                    <line
                        class="mSquare-6"
                        x1="66.23"
                        y1="95.18"
                        x2="98.14"
                        y2="95.18"
                    />
                </g>
                }
            </g>
            <g class="field3" (click)="setActiveField(3)">
                <rect
                    class="mSquare-4"
                    x="116.75"
                    y="58.75"
                    width="46.5"
                    height="46.5"
                />
                <text
                    class="mSquare-5"
                    text-anchor="middle"
                    transform="translate(139.75 92.52)"
                >
                    {{ values[3] }}
                </text>
                @if (activeField === 3) {
                <g>
                    <line
                        class="mSquare-6"
                        x1="123.23"
                        y1="95.18"
                        x2="155.14"
                        y2="95.18"
                    />
                </g>
                }
            </g>
            <g class="field4" (click)="setActiveField(4)">
                <circle class="mSquare-4" cx="198" cy="82" r="23.25" />
                <text
                    class="mSquare-5"
                    text-anchor="middle"
                    transform="translate(197.75 92.52)"
                >
                    {{ values[4] }}
                </text>
                @if (activeField === 4) {
                <g>
                    <line
                        class="mSquare-6"
                        x1="182.23"
                        y1="95.18"
                        x2="214.14"
                        y2="95.18"
                    />
                </g>
                }
            </g>
            <g class="field5" (click)="setActiveField(5)">
                <rect
                    class="mSquare-4"
                    x="0.75"
                    y="116.75"
                    width="46.5"
                    height="46.5"
                />
                <text
                    class="mSquare-5"
                    text-anchor="middle"
                    transform="translate(23.75 150.52)"
                >
                    {{ values[5] }}
                </text>
                @if (activeField === 5) {
                <g>
                    <line
                        class="mSquare-6"
                        x1="8.23"
                        y1="153.18"
                        x2="40.14"
                        y2="153.18"
                    />
                </g>
                }
            </g>
            <g class="field6" (click)="setActiveField(6)">
                <rect
                    class="mSquare-4"
                    x="58.75"
                    y="116.75"
                    width="46.5"
                    height="46.5"
                />
                <text
                    class="mSquare-5"
                    text-anchor="middle"
                    transform="translate(81.75 150.52)"
                >
                    {{ values[6] }}
                </text>
                @if (activeField === 6) {
                <g>
                    <line
                        class="mSquare-6"
                        x1="66.23"
                        y1="153.18"
                        x2="98.14"
                        y2="153.18"
                    />
                </g>
                }
            </g>
            <g class="field7" (click)="setActiveField(7)">
                <rect
                    class="mSquare-4"
                    x="116.75"
                    y="116.75"
                    width="46.5"
                    height="46.5"
                />
                <text
                    class="mSquare-5"
                    text-anchor="middle"
                    transform="translate(139.75 150.52)"
                >
                    {{ values[7] }}
                </text>
                @if (activeField === 7) {
                <g>
                    <line
                        class="mSquare-6"
                        x1="123.23"
                        y1="153.18"
                        x2="155.14"
                        y2="153.18"
                    />
                </g>
                }
            </g>
            <g class="field8" (click)="setActiveField(8)">
                <circle class="mSquare-4" cx="198" cy="140" r="23.25" />
                <text
                    class="mSquare-5"
                    text-anchor="middle"
                    transform="translate(197.75 150.52)"
                >
                    {{ values[8] }}
                </text>
                @if (activeField === 8) {
                <g>
                    <line
                        class="mSquare-6"
                        x1="182.23"
                        y1="153.18"
                        x2="214.14"
                        y2="153.18"
                    />
                </g>
                }
            </g>
            <g class="field9" (click)="setActiveField(9)">
                <rect
                    class="mSquare-4"
                    x="0.75"
                    y="174.75"
                    width="46.5"
                    height="46.5"
                />
                <text
                    class="mSquare-5"
                    text-anchor="middle"
                    transform="translate(23.75 208.52)"
                >
                    {{ values[9] }}
                </text>
                @if (activeField === 9) {
                <g>
                    <line
                        class="mSquare-6"
                        x1="8.23"
                        y1="211.18"
                        x2="40.14"
                        y2="211.18"
                    />
                </g>
                }
            </g>
            <g class="field10" (click)="setActiveField(10)">
                <rect
                    class="mSquare-4"
                    x="58.75"
                    y="174.75"
                    width="46.5"
                    height="46.5"
                />
                <text
                    class="mSquare-5"
                    text-anchor="middle"
                    transform="translate(81.75 208.52)"
                >
                    {{ values[10] }}
                </text>
                @if (activeField === 10) {
                <g>
                    <line
                        class="mSquare-6"
                        x1="66.23"
                        y1="211.18"
                        x2="98.14"
                        y2="211.18"
                    />
                </g>
                }
            </g>
            <g class="field11" (click)="setActiveField(11)">
                <rect
                    class="mSquare-4"
                    x="116.75"
                    y="174.75"
                    width="46.5"
                    height="46.5"
                />
                <text
                    class="mSquare-5"
                    text-anchor="middle"
                    transform="translate(139.75 208.52)"
                >
                    {{ values[11] }}
                </text>
                @if (activeField === 11) {
                <g>
                    <line
                        class="mSquare-6"
                        x1="123.23"
                        y1="211.18"
                        x2="155.14"
                        y2="211.18"
                    />
                </g>
                }
            </g>
            <g class="field12" (click)="setActiveField(12)">
                <circle class="mSquare-4" cx="198" cy="198" r="23.25" />
                <text
                    class="mSquare-5"
                    text-anchor="middle"
                    transform="translate(197.75 208.52)"
                >
                    {{ values[12] }}
                </text>
                @if (activeField === 12) {
                <g>
                    <line
                        class="mSquare-6"
                        x1="182.23"
                        y1="211.18"
                        x2="214.14"
                        y2="211.18"
                    />
                </g>
                }
            </g>
            <g class="field13" (click)="setActiveField(13)">
                <circle class="mSquare-4" cx="24" cy="256" r="23.25" />
                <text
                    class="mSquare-5"
                    text-anchor="middle"
                    transform="translate(23.75 266.52)"
                >
                    {{ values[13] }}
                </text>
                @if (activeField === 13) {
                <g>
                    <line
                        class="mSquare-6"
                        x1="8.23"
                        y1="269.18"
                        x2="40.14"
                        y2="269.18"
                    />
                </g>
                }
            </g>
            <g class="field14" (click)="setActiveField(14)">
                <circle class="mSquare-4" cx="82" cy="256" r="23.25" />
                <text
                    class="mSquare-5"
                    text-anchor="middle"
                    transform="translate(81.75 266.52)"
                >
                    {{ values[14] }}
                </text>
                @if (activeField === 14) {
                <g>
                    <line
                        class="mSquare-6"
                        x1="66.23"
                        y1="269.18"
                        x2="98.14"
                        y2="269.18"
                    />
                </g>
                }
            </g>
            <g class="field15" (click)="setActiveField(15)">
                <circle class="mSquare-4" cx="140" cy="256" r="23.25" />
                <text
                    class="mSquare-5"
                    text-anchor="middle"
                    transform="translate(139.75 266.52)"
                >
                    {{ values[15] }}
                </text>
                @if (activeField === 15) {
                <g>
                    <line
                        class="mSquare-6"
                        x1="123.23"
                        y1="269.18"
                        x2="155.14"
                        y2="269.18"
                    />
                </g>
                }
            </g>
            <g class="field16" (click)="setActiveField(16)">
                <circle class="mSquare-4" cx="198" cy="256" r="23.25" />
                <text
                    class="mSquare-5"
                    text-anchor="middle"
                    transform="translate(197.75 266.52)"
                >
                    {{ values[16] }}
                </text>
                @if (activeField === 16) {
                <g>
                    <line
                        class="mSquare-6"
                        x1="182.23"
                        y1="269.18"
                        x2="214.14"
                        y2="269.18"
                    />
                </g>
                }
            </g>
        </g>
    </svg>
</ng-template>
